// extracted by mini-css-extract-plugin
module.exports = {"svg":"Preloader_svg__2f6kK","cont":"Preloader_cont__3QXvA"};